module.exports = __webpack_public_path__ + "media/images/smart_phone/topic_2-838f1f01c4a3172598ef2940fcc341d9.png";